@if (addsBoard()) {
  <app-context-menu-item title="Add new board" popoverAppearance="dialog">
    <div class="box-border w-[var(--quick-form-dialog-width)]">
      <app-panel-board-create (created)="openCreated($event)" />
    </div>
  </app-context-menu-item>
}
@if (addsFolder()) {
  <app-context-menu-item title="Add new folder" popoverAppearance="dialog">
    <div class="box-border w-[var(--quick-form-dialog-width-rail)]">
      <app-boards-quick-form placeholder="Untitled folder" [autofocus]="true" [createFromForm]="fileFolder" (close)="close()" />
    </div>
  </app-context-menu-item>
}
@if (action(); as action) {
  @if (addsBoard() || addsFolder()) {
    <app-context-menu-divider />
  }
  <app-context-menu-item [title]="action.title" [close]="true" (execute)="action.execute()" />
}
